const pxl = (userId: string) => {
  // @ts-expect-error
  window.fcpixel?.pxl(27514, userId, "registrationComplete", "", 0, 0, "", "futuremoneyFC");
};

export const FintelConnect = { pxl };
